import {
  BarChart3Icon,
  BellIcon,
  BookOpenIcon,
  Building2Icon,
  CalendarDaysIcon,
  ClipboardListIcon,
  FileIcon,
  FileTextIcon,
  GiftIcon,
  GraduationCapIcon,
  HistoryIcon,
  HourglassIcon,
  InboxIcon,
  LayoutDashboard,
  ListChecks,
  MegaphoneIcon,
  MonitorIcon,
  PackageIcon,
  PercentIcon,
  ReceiptIcon,
  ScrollTextIcon,
  ShoppingCartIcon,
  StarIcon,
  SwordsIcon,
  TagsIcon,
  UserCog,
  Users,
  UsersIcon,
  WalletIcon,
} from "lucide-react";
import type { NavGroup, SidebarData } from "../types";

export const sidebarData: SidebarData = {
  teams: [],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/dashboard",
          icon: LayoutDashboard,
        },
        {
          title: "ລົງທະບຽນ / ຂາຍ",
          icon: ShoppingCartIcon,
          requiredPermissions: ["packages:sell", "private-lessons:sell"],
          items: [
            {
              title: "ຂາຍ",
              url: "/app/sell",
              requiredPermissions: ["packages:sell", "private-lessons:sell"],
            },
            {
              title: "Partner ລໍຖ້າ lock",
              url: "/app/sell/partner/pending-lock",
              requiredPermissions: ["packages:sell"],
            },
          ],
        },
        {
          title: "ການເຂົ້າຮຽນ",
          icon: ClipboardListIcon,
          requiredPermissions: ["classes:read", "private-lessons:read"],
          items: [
            {
              title: "ກວດຊື່",
              url: "/app/attendance/check-in",
              requiredPermissions: ["classes:read", "private-lessons:read"],
            },
            {
              title: "ບັນທຶກການເຂົ້າຮຽນ",
              url: "/app/attendance/records",
              requiredPermissions: ["classes:read", "private-lessons:read"],
            },
          ],
        },
        {
          title: "Studio",
          url: "/studio",
          icon: MonitorIcon,
        },
      ],
    },
    {
      title: "ນັກຮຽນ · ແພັກເກດ",
      items: [
        {
          title: "ນັກຮຽນ",
          url: "/app/students",
          icon: GraduationCapIcon,
          requiredPermissions: ["students:read", "packages:sell"],
        },
        {
          title: "ແມ່ແບບແພັກເກດ",
          icon: PackageIcon,
          items: [
            {
              title: "ແພັກເກດຄລາສ໌ (ແມ່ແບບ)",
              url: "/app/packages/templates",
              requiredPermissions: ["packages:read"],
            },
            {
              title: "ແພັກເກດຮຽນສ່ວນຕົວ (ແມ່ແບບ)",
              url: "/app/private-lessons/templates",
              requiredPermissions: ["private-lessons:read"],
            },
          ],
        },
      ],
    },
    {
      title: "ຮຽນສ່ວນຕົວ (ດຳເນີນງານ)",
      items: [
        {
          title: "ນັກຮຽນທີ່ມີແພັກເກດຮຽນສ່ວນຕົວ",
          url: "/app/private-lessons/packages",
          icon: UsersIcon,
          requiredPermissions: ["private-lessons:read"],
        },
        {
          title: "ການຈອງຮຽນສ່ວນຕົວ",
          url: "/app/private-lessons/bookings",
          icon: CalendarDaysIcon,
          requiredPermissions: ["private-lessons:read"],
        },
      ],
    },
    {
      title: "ຄລາດສ໌ກຸ່ມ",
      items: [
        {
          title: "Template ຄລາດສ໌",
          url: "/app/classes/templates",
          icon: ClipboardListIcon,
          requiredPermissions: ["classes:read"],
        },
        {
          title: "ໃບສະໝັກຮຽນ",
          url: "/app/class-enrollments",
          icon: InboxIcon,
          requiredPermissions: ["class-enrollments:read"],
        },
        {
          title: "ຕາຕະລາງ",
          url: "/app/classes/schedule",
          icon: CalendarDaysIcon,
          requiredPermissions: ["classes:read"],
        },
        {
          title: "ຈັດຕາຕະລາງຄລາດສ໌",
          url: "/app/classes/sessions",
          icon: CalendarDaysIcon,
          requiredPermissions: ["classes:read"],
        },
        {
          title: "ບັນທຶກການປ່ຽນແປງຕາຕະລາງ",
          url: "/app/classes/schedule-logs",
          icon: HistoryIcon,
          requiredPermissions: ["classes:read"],
        },
      ],
    },
    {
      title: "ຫ້ອງ ແລະ ການເງິນ",
      items: [
        {
          title: "ການຈອງຫ້ອງ",
          url: "/app/room-bookings",
          icon: CalendarDaysIcon,
          requiredPermissions: ["room-bookings:read"],
        },
        {
          title: "ຈໍສະແດງຜົນ",
          url: "/app/room-displays",
          icon: MonitorIcon,
          requiredPermissions: ["room-displays:read"],
        },
        {
          title: "ເອກະສານການເງິນ",
          icon: ReceiptIcon,
          items: [
            {
              title: "ໃບເກັບເງິນ",
              url: "/app/billing/receipts",
              requiredPermissions: ["billing:read"],
            },
            {
              title: "ໃບເກັບເງິນ / ຊຳລະບາງສ່ວນ",
              url: "/app/billing/credit-invoices",
              requiredPermissions: ["billing:read"],
            },
            {
              title: "ຄຳຂໍຄືນເງິນ",
              url: "/app/refunds",
              requiredPermissions: ["refunds:read"],
            },
          ],
        },
      ],
    },
    {
      title: "ຂໍ້ມູນພື້ນຖານ",
      items: [
        {
          title: "ປະເພດຄລາດສ໌",
          url: "/app/master/class-types",
          icon: BookOpenIcon,
          requiredPermissions: ["master:read"],
        },
        {
          title: "ລະດັບ",
          url: "/app/master/levels",
          icon: GraduationCapIcon,
          requiredPermissions: ["master:read"],
        },
        {
          title: "ຫ້ອງຮຽນ",
          url: "/app/master/rooms",
          icon: FileIcon,
          requiredPermissions: ["master:read"],
        },
        {
          title: "ຄູສອນ",
          url: "/app/master/instructors",
          icon: Users,
          requiredPermissions: ["master:read"],
        },
        {
          title: "ກຸ່ມນັກຮຽນ",
          url: "/app/master/student-groups",
          icon: GraduationCapIcon,
          requiredPermissions: ["master:read"],
        },
      ],
    },
    {
      title: "ແຈ້ງເຕືອນ",
      items: [
        {
          title: "ແຈ້ງເຕືອນ WhatsApp",
          url: "/app/package-notifications",
          icon: BellIcon,
          requiredPermissions: ["package-notifications:read"],
        },
      ],
    },
    {
      title: "ລາຍງານ",
      items: [
        {
          title: "ການເຂົ້າຮຽນ",
          icon: BarChart3Icon,
          requiredPermissions: ["reports:read"],
          items: [
            {
              title: "ການເຂົ້າຫ້ອງ ແລະ ຄູ",
              requiredPermissions: ["reports:read"],
              items: [
                {
                  title: "ລາຍງານການເຂົ້າຮຽນ",
                  url: "/app/reports/attendance",
                  requiredPermissions: ["reports:read"],
                },
                {
                  title: "ສະຫຼຸບຄ່າຈ້າງຄູຕາມເດືອນ",
                  url: "/app/reports/instructor-monthly-payout",
                  requiredPermissions: ["reports:read"],
                },
              ],
            },
            {
              title: "ລາຍງານການໃຊ້ຄວາມຈຸຄລາດສ໌",
              url: "/app/reports/class-capacity",
              requiredPermissions: ["reports:read"],
            },
          ],
        },
        {
          title: "ລາຍງານການໃຊ້ຫ້ອງ",
          url: "/app/reports/room-usage",
          icon: Building2Icon,
          requiredPermissions: ["reports:read"],
        },
        {
          title: "ລາຍໄດ້ · ແພັກເກດ · ຄືນເງິນ",
          icon: ReceiptIcon,
          requiredPermissions: ["reports:read"],
          items: [
            {
              title: "ລາຍງານລາຍຮັບ / ຍອດຂາຍ",
              url: "/app/reports/revenue",
              requiredPermissions: ["reports:read"],
            },
            {
              title: "ລາຍງານຍອດຂາຍແພັກເກດ",
              url: "/app/reports/package-sales",
              requiredPermissions: ["reports:read"],
            },
            {
              title: "ລາຍງານຍອດຂາຍຕາມປະເພດຄລາສ",
              url: "/app/reports/class-type-sales",
              requiredPermissions: ["reports:read"],
            },
            {
              title: "ລາຍງານການຄືນເງິນ",
              url: "/app/reports/refund",
              requiredPermissions: ["reports:read"],
            },
          ],
        },
        {
          title: "ນັກຮຽນ",
          icon: GraduationCapIcon,
          requiredPermissions: ["reports:read"],
          items: [
            {
              title: "ລາຍງານນັກຮຽນ",
              url: "/app/reports/students",
              requiredPermissions: ["reports:read"],
            },
            {
              title: "ນັກຮຽນ Active ຕາມຄລາສ",
              url: "/app/reports/active-students-by-class",
              requiredPermissions: ["reports:read"],
            },
          ],
        },
      ],
    },
  ],
};

const accessControlNavGroup: NavGroup = {
  title: "ການຄວບຄຸມການເຂົ້າເຖິງ",
  items: [
    {
      title: "ບົດບາດ",
      url: "/app/roles",
      icon: UserCog,
      requiredPermissions: ["users:read"],
    },
    {
      title: "ຜູ້ໃຊ້",
      url: "/app/users",
      icon: Users,
      requiredPermissions: ["users:read"],
    },
  ],
};

sidebarData.navGroups.push(accessControlNavGroup);

export const performanceSidebarData: SidebarData = {
  teams: [],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/performance/dashboard",
          icon: LayoutDashboard,
        },
      ],
    },
    {
      title: "ການຈັດການງານສະແດງ",
      items: [
        {
          title: "ຄິວ",
          url: "/app/performance/requests",
          icon: ClipboardListIcon,
          requiredPermissions: ["performance-requests:read"],
        },
        {
          title: "ງານສະແດງ",
          url: "/app/performance/events",
          icon: StarIcon,
          requiredPermissions: ["performance-events:read"],
        },
        {
          title: "ຫມວດງານສະແດງ",
          url: "/app/performance/settings/event-categories",
          icon: TagsIcon,
          requiredPermissions: ["performance-events:read"],
        },
        {
          title: "ນັກສະແດງ",
          url: "/app/performance/performers",
          icon: UsersIcon,
          requiredPermissions: ["performers:read"],
        },
        {
          title: "Staff",
          url: "/app/performance/staff",
          icon: UserCog,
          requiredPermissions: ["performance-payouts:read"],
        },
        {
          title: "Outsource",
          url: "/app/performance/outsources",
          icon: MegaphoneIcon,
          requiredPermissions: ["performance-events:read"],
        },
        {
          title: "ຄ່າຕົວຕາມບົດບາດ",
          url: "/app/performance/role-fees",
          icon: WalletIcon,
          requiredPermissions: ["performance-role-fees:read"],
        },
        {
          title: "ເບ້ຍລ້ຽງຕ່າງແຂວງ",
          url: "/app/performance/per-diem",
          icon: TagsIcon,
          requiredPermissions: ["performance-per-diem:read"],
        },
      ],
    },
    {
      title: "ເອກະສານ & ເງິນ",
      items: [
        {
          title: "ເອກະສານ",
          url: "/app/performance/documents",
          icon: FileTextIcon,
          requiredPermissions: ["performance-documents:read"],
        },
        {
          title: "ແມ່ແບບເງື່ອນໄຂຊຳລະ",
          url: "/app/performance/payment-terms-templates",
          icon: FileTextIcon,
          requiredPermissions: ["performance-payment-terms:read"],
        },
        {
          title: "ແມ່ແບບບັນຊີທະນາຄານ",
          url: "/app/performance/bank-account-templates",
          icon: FileTextIcon,
          requiredPermissions: ["performance-bank-account:read"],
        },
        {
          title: "ແມ່ແບບແຜນງວດຊຳລະ",
          url: "/app/performance/installment-plan-templates",
          icon: CalendarDaysIcon,
          requiredPermissions: ["performance-documents:read"],
        },
        {
          title: "ຕັ້ງຄ່າພາສີເອກະສານ",
          url: "/app/performance/tax-settings",
          icon: PercentIcon,
          requiredPermissions: ["performance-documents:read"],
        },
        {
          title: "ໃບເບີກຈ່າຍນັກສະແດງ",
          url: "/app/performance/payouts",
          icon: WalletIcon,
          requiredPermissions: ["performance-payouts:read"],
        },
      ],
    },
    {
      title: "ລາຍງານ",
      items: [
        {
          title: "ພາບລວມ",
          url: "/app/performance/reports",
          icon: BarChart3Icon,
          requiredPermissions: ["performance-reports:read"],
        },
        {
          title: "ງານສະແດງ",
          url: "/app/performance/reports/events",
          icon: BarChart3Icon,
          requiredPermissions: ["performance-reports:read"],
        },
        {
          title: "ຄຳຂໍ",
          url: "/app/performance/reports/requests",
          icon: BarChart3Icon,
          requiredPermissions: ["performance-reports:read"],
        },
        {
          title: "ນັກສະແດງ",
          url: "/app/performance/reports/performers",
          icon: BarChart3Icon,
          requiredPermissions: ["performance-reports:read"],
        },
        {
          title: "ຈ່າຍນັກສະແດງ",
          url: "/app/performance/reports/payouts",
          icon: BarChart3Icon,
          requiredPermissions: ["performance-reports:read"],
        },
        {
          title: "ລາຍຮັບ",
          url: "/app/performance/reports/revenue",
          icon: BarChart3Icon,
          requiredPermissions: ["performance-reports:read"],
        },
      ],
    },
    accessControlNavGroup,
  ],
};

export const eventsSidebarData: SidebarData = {
  teams: [],
  navGroups: [
    {
      title: "Summer Camp",
      items: [
        {
          title: "ຕັ້ງຄ່າ Summer Camp",
          url: "/app/camp-events",
          icon: CalendarDaysIcon,
          requiredPermissions: ["camp-events:read"],
        },
        {
          title: "ໃບສະໝັກ Camp",
          url: "/app/camp-registrations",
          icon: InboxIcon,
          requiredPermissions: ["camp-registrations:read"],
        },
        {
          title: "ຄິວສຳຮອງ Camp",
          url: "/app/camp-registrations/waitlist",
          icon: HourglassIcon,
          requiredPermissions: ["camp-registrations:read"],
        },
      ],
    },
    {
      title: "Fanglao Jam",
      items: [
        {
          title: "ຕັ້ງຄ່າ Fanglao Jam",
          url: "/app/jam-events",
          icon: SwordsIcon,
          requiredPermissions: ["jam-events:read"],
        },
        {
          title: "ໃບສະໝັກ Jam",
          url: "/app/jam-registrations",
          icon: ScrollTextIcon,
          requiredPermissions: ["jam-registrations:read"],
        },
      ],
    },
    {
      title: "Workshop",
      items: [
        {
          title: "ໃບສະໝັກ Workshop",
          url: "/app/workshop-registrations",
          icon: ScrollTextIcon,
          requiredPermissions: ["workshop-registrations:read"],
        },
      ],
    },
    {
      title: "Visitor Lottery",
      items: [
        {
          title: "ຕັ້ງຄ່າ Visitor Lottery",
          url: "/app/visitor-lottery",
          icon: GiftIcon,
          requiredPermissions: ["visitor-lottery:read"],
        },
        {
          title: "ລາຍຊື່ຜູ້ເຂົ້າຊົມ",
          url: "/app/visitor-lottery/registrations",
          icon: InboxIcon,
          requiredPermissions: ["visitor-lottery:read"],
        },
        {
          title: "Scanner ຮັບຂອງ",
          url: "/app/visitor-lottery/scanner",
          icon: GiftIcon,
          requiredPermissions: ["visitor-lottery:write"],
        },
        {
          title: "ລາຍງານ Visitor Lottery",
          url: "/app/visitor-lottery/report",
          icon: BarChart3Icon,
          requiredPermissions: ["visitor-lottery:read"],
        },
      ],
    },
    accessControlNavGroup,
  ],
};

export const expensesSidebarData: SidebarData = {
  teams: [],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/expenses/overview",
          icon: LayoutDashboard,
        },
      ],
    },
    {
      title: "ຄ່າໃຊ້ຈ່າຍ",
      items: [
        {
          title: "ບັນທຶກຄ່າໃຊ້ຈ່າຍ",
          url: "/app/expenses",
          icon: WalletIcon,
          requiredPermissions: ["expenses:read"],
        },
        {
          title: "ຫມວດຄ່າໃຊ້ຈ່າຍ",
          url: "/app/expenses/categories",
          icon: TagsIcon,
          requiredPermissions: ["expenses:manage-categories"],
        },
      ],
    },
    accessControlNavGroup,
  ],
};

export const formsSidebarData: SidebarData = {
  teams: [],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ແຜງຟອມ",
          url: "/app/forms/dashboard",
          icon: LayoutDashboard,
        },
      ],
    },
    {
      title: "ຟອມ",
      items: [
        {
          title: "ຟອມທັງໝົດ",
          url: "/app/forms",
          icon: ListChecks,
          requiredPermissions: ["forms:read"],
        },
        {
          title: "ຫມວດຫມູ່ຟອມ",
          url: "/app/forms/categories",
          icon: TagsIcon,
          requiredPermissions: ["forms:read"],
        },
        {
          title: "ສ້າງຟອມໃໝ່",
          url: "/app/forms/new",
          icon: FileTextIcon,
          requiredPermissions: ["forms:create"],
        },
      ],
    },
    {
      title: "Audience Vote",
      items: [
        {
          title: "ຕັ້ງຄ່າ Audience Vote",
          url: "/app/audience-vote",
          icon: StarIcon,
          requiredPermissions: ["audience-vote:read"],
        },
      ],
    },
    accessControlNavGroup,
  ],
};
